<div class="section-title section-title--cardgrading" title="Image contains stacks of SGC graded cards">
    <h2>CARD GRADING SERVICES AND FEES</h2>
</div>
<ul class="submenu">
    <li>
        <a routerLink="/card-grading/services-pricing" routerLinkActive="submenu__item--active" class="submenu__item"> STANDARD Services and Pricing</a>
    </li>
    <li>
        <a routerLink="/card-grading/tcg-services-pricing" routerLinkActive="submenu__item--active" class="submenu__item "> TCG Services and Pricing</a>
    </li>
    <li>
        <a routerLink="/card-grading/shipping-fees" routerLinkActive="submenu__item--active" class="submenu__item "> Shipping Fees</a>
    </li>

    <li><a routerLink="/card-grading/scale" routerLinkActive="submenu__item--active" class="submenu__item">SGC Grading Scale</a></li>
</ul>
<router-outlet></router-outlet>